module.exports = __webpack_public_path__ + "static/img/life-style0.35a483bb.png";